import Resource from '@/api/Resource';
import TestQuestion from '@/models/TestQuestion';
import Category from '@/models/Category';

class Test extends Resource {
  $name = 'tests';

  $defaults() {
    return {
      id: null,
      active: 0,
      name: '',
      description: '',
      category_id: null,
      need_scores: 0,
      questions_in_random_order: false,
      shown_questions_count: null,
      start_date: null,
      end_date: null,
      time_limit: null,
      attempts_count: 0,
      can_change_answer: false,
      commentable: false,
    };
  }

  $fill({ questions, category }) {
    if (questions) {
      this.questions = TestQuestion.collection(questions);
    }

    if (category) {
      this.category = new Category(category);
    }
  }

  canStartTest() {
    return !this.attempts_count || this.user_sessions.length < this.attempts_count;
  }
}

export default Test;
